import { useCallback } from 'react';

import { useDrawer } from '@cast/design-system';

import { RestrictionsDrawer } from './RestrictionsDrawer';
import { RestrictionsDrawerProps } from './types';

export const useRestrictionsDrawer = () => {
  const { open } = useDrawer();

  const openRestrictionsDrawer = useCallback(
    (props: RestrictionsDrawerProps) => {
      open({
        component: RestrictionsDrawer,
        props,
      });
    },
    [open]
  );

  return {
    openRestrictionsDrawer,
  };
};
